import { render, staticRenderFns } from "./TemplateReportEditPage.vue?vue&type=template&id=33593de6"
import script from "./TemplateReportEditPage.vue?vue&type=script&lang=ts"
export * from "./TemplateReportEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports